import { Box } from '@chakra-ui/react'
import React from 'react'
import { useClient } from '../core/client/ClientProvider'

/** Client-owned SVG silhouettes inherit text colour, including hover and selection. */
export function ClientIcon({
  name,
  group,
  size,
  fallback,
}: {
  name: string
  group: 'navigation' | 'agents'
  size: number
  fallback: React.ReactElement
}) {
  const { config } = useClient()
  const src = config?.theme.icons?.[group]?.[name]
  if (!src) return fallback
  const mask = `url("${src}") center / contain no-repeat`
  return (
    <Box
      as='span'
      aria-hidden='true'
      data-client-icon={`${group}:${name}`}
      display='inline-block'
      flexShrink={0}
      w={`${size}px`}
      h={`${size}px`}
      bg='currentColor'
      sx={{ mask, WebkitMask: mask }}
    />
  )
}
